import { DashboardLayout } from "@/components/dashboard/dashboard-layout";
import CompanyProfile from "./CompanyProfile";

export default function CompanyProfilePage() {
  return (
    <DashboardLayout activeTab="company-profile">
      <CompanyProfile />
    </DashboardLayout>
  );
}
